import { Controller } from "stimulus"
import OS from "../lib/os"
import CookieService from "../lib/cookie"
import M from "../materialize"
import { reviewFrame } from "../review-frame/snapshot"

export default class ExitController extends Controller {

  modal = null
  os = new OS()
  beenShownCookie = false

  static get targets() {
    return ['modal']
  }


  maybeShowModal(e) {
    const shouldShowExitIntent =
      !e.toElement &&
      !e.relatedTarget &&
      e.clientY < 10;

    if (shouldShowExitIntent) {
      document.removeEventListener('mouseout', this.maybeShowModalBound);
      this.modal.open()
      CookieService.setCookie('exit-intent-shown', true, 7)
    }

  }
  maybeShowModalBound = this.maybeShowModal.bind(this)

  initialize() {
    this.beenShownCookie = CookieService.getCookie('exit-intent-shown') == 'true'
    this.modal = M.Modal.getInstance(this.modalTarget)
    // In the translation review app the pointer leaves the page all the time;
    // the app opens the popup on purpose instead.
    if (this.os.desktop() && !this.beenShownCookie && !reviewFrame) {
      setTimeout(() => {
        document.addEventListener('mouseout', this.maybeShowModalBound);
      }, 0);
    }
  }

  disconnect() {
    this.modal.destroy()
  }

}